import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormEditor from './FormEditor';

const CheckboxComponent = ({ value, onChange, editor, disabled, errors, data }) => {
  const { id, name, label } = editor;
  const {
    margin = 'normal',
    description,
    minWidth,
    maxWidth,
    dense,
    required,
  } = editor.property;

  const handleChange = (event) => {
    onChange(name, event.target.checked);
  };

  const error = errors && errors.length && errors[0];
  const helperText = error || description || undefined;
  let style;
  if (minWidth || maxWidth) {
    style = {
      minWidth: minWidth ? `${minWidth}px` : undefined,
      maxWidth: maxWidth ? `${maxWidth}px` : undefined,
    };
  }
  const { displayed = true, ...userProps } = editor.componentProps(data) || {};

  return (
    <FormControl
      key={id}
      id={id}
      error={!!error}
      className={classnames(
        'grb-form-editor',
        'grb-form-editor-boolean',
        dense && 'grb-form-editor-dense',
        !displayed && 'grb-form-editor-not-displayed',
      )}
      margin={margin}
      style={style}
      required={required}
      {...userProps}
    >
      <FormControlLabel
        control={<Checkbox checked={value} onChange={handleChange} name={name} />}
        label={label}
        disabled={disabled}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

CheckboxComponent.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number,
  ]),
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string),
  editor: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    id: PropTypes.string,
    property: PropTypes.shape({
      type: PropTypes.string,
      description: PropTypes.string,
      multiline: PropTypes.bool,
      dense: PropTypes.bool,
      readOnly: PropTypes.bool,
      min: PropTypes.number,
      max: PropTypes.number,
      autoComplete: PropTypes.string,
      startAdornment: PropTypes.string,
      endAdornment: PropTypes.string,
      margin: PropTypes.string,
      fullWidth: PropTypes.bool,
      minWidth: PropTypes.number,
      maxWidth: PropTypes.number,
      required: PropTypes.bool,
    }),
    componentProps: PropTypes.func,
  }).isRequired,
  disabled: PropTypes.bool,
  data: PropTypes.shape({}).isRequired,
};

CheckboxComponent.defaultProps = {
  value: undefined,
  errors: undefined,
  disabled: undefined,
};

class BooleanFormEditor extends FormEditor {
  constructor(property, options) {
    super(property, options);
    this.Component = CheckboxComponent;
    this.componentProps = options && options.props || (() => {});
  }
}

export default BooleanFormEditor;
